'use client';

import { useRouter } from 'next/navigation';
import { useTransition } from 'react';

import { enableDraftMode } from '@/lib/server/draft-mode';
import { Button } from '@/ui/Button';
import { Icon } from '@/ui/Icon';

export function EnterPreviewButton() {
    const router = useRouter();
    const [isPending, start] = useTransition();

    return (
        <Button
            className="px-3 py-0 text-xs max-md:w-md max-md:p-0"
            disabled={isPending}
            onClick={async () => {
                await enableDraftMode();

                start(router.refresh);
            }}
        >
            <Icon className="text-2xl">preview</Icon>
            <span className="py-2 max-md:hidden">Enter Preview Mode</span>
        </Button>
    );
}
